import { Component, OnInit, Injector } from '@angular/core';
import { LoginComponent } from '@mango/authentication';
import { MatDialog } from '@angular/material/dialog';
import { ForgotPasswordDialogComponent } from './forgot-password/forgot-password-dialog.component';

import packageInfo from 'package.json';

@Component({
    selector: 'cij-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class CIJLoginComponent extends LoginComponent implements OnInit {

    randomNumber: number;
    forgotPasswordEmail: string;
    MiLabProVersion: string;

    backgroundPictureCount: number = 1;

    constructor(injector: Injector, public dialog: MatDialog) {
        super(injector);

        this.randomNumber = Math.floor(Math.random() * this.backgroundPictureCount) + 1
        this.MiLabProVersion = packageInfo.version;

    }

    getRandomBackground(): string {
        return `assets/login-photos/${this.randomNumber}.jpg`;
    }

    openForgotPasswordDialog() {
        this.dialog.open(ForgotPasswordDialogComponent, { width: '500px' });
    }

}
